module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_vestland_pos.6850c110.png";